import { IconProp } from "@fortawesome/fontawesome-svg-core";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ElementSize } from "features/shared/enums/elementSize";

import styles from "./roundbutton.module.scss";
import { Link } from "react-router-dom";
import { LocationDescriptor } from "history";

interface Props {
  icon?: IconProp;
  size?: ElementSize;
  asLink?: boolean;
  to?: LocationDescriptor;
  onClickHandler?: () => void;
  className?: string;
}

const RoundButton = ({ icon = "search", size = "sm", asLink = false, to, onClickHandler, className }: Props) => {
  // helpers
  const getClasses = (size?: ElementSize) => {
    let sizeClass = size !== undefined ? ` btn-${size}` : '';
    let propsClass = className ? ` ${className}` : "";
    return `btn${sizeClass} ${styles.roundBtn}${propsClass}`;
  }

  // render
  if (asLink) {
    return (
      <Link className={getClasses(size)} to={to !== undefined ? to : {}}>
        <FontAwesomeIcon icon={icon} />
      </Link>
    );
  } else {
    return (
      <button type="button" className={getClasses(size)} onClick={onClickHandler}>
        <FontAwesomeIcon icon={icon} />
      </button>
    );
  }
};

export default RoundButton;